function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import { useAction, useOnClickOutside } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import Hcp from 'modules/Hcp';
import Download from 'svg/download.svg';
import ReportAgpIcon from 'svg/report-captur-agp.svg';
import ChevronRight from 'svg/chevron-right.svg';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import ExportDataModal from '../ExportDataModal';
import styles from './ExportDataMenu.pcss';
const ExportDataMenu = ()=>{
    useStyles(styles);
    const isInProgress = useSelector(selectors.isExportDataInProgress);
    const patients = useSelector(Hcp.selectors.patients);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const dropdownRef = useRef(null);
    const onExport = useAction(actions.exportData);
    const onOpenModal = useAction(App.actions.openModal, constants.EXPORT_DATA_MODAL);
    const [isOpen, setIsOpen] = useState(false);
    const open = ()=>setIsOpen(true);
    const close = useCallback(()=>setIsOpen(false), []);
    useOnClickOutside(dropdownRef, close);
    const onBtnClick = ()=>{
        close();
        onExport('patientsBloodGlucoseExport', {
            patients,
            clinicMembership: activeClinicMembership
        });
        onOpenModal();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.topBar__generateReport,
        children: [
            /*#__PURE__*/ _jsxs(Button, {
                styleModifier: "transparent",
                className: cn(styles.topBar__button, styles['topBar__button--right'], styles['topBar__button--active']),
                isDisabled: isInProgress,
                onClick: open,
                children: [
                    /*#__PURE__*/ _jsx(Download, {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.exportData)),
                    /*#__PURE__*/ _jsx(ChevronRight, {
                        className: styles.chevronIcon
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ _jsx("div", {
                className: styles.topBar__generateReportDropdown,
                ref: dropdownRef,
                children: /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs("button", {
                        type: "button",
                        className: styles.reportSelector__button,
                        onClick: onBtnClick,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.reportSelector__icon,
                                children: /*#__PURE__*/ _jsx(ReportAgpIcon, {})
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.reportSelector__label,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.patientsBloodGlucoseExport))
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ExportDataModal, {})
        ]
    });
};
export default ExportDataMenu;
